import React from 'react';
import { num0 } from '../../lib/numeros';

export const COLOR_MACRO = { P: '#FF4B4B', H: '#FACC15', G: '#2DD4BF' };
const NOMBRE = { P: 'Proteína', H: 'Carbohidratos', G: 'Grasas' };
// En móvil las tres tarjetas van en columnas de ~100 px: «Carbohidratos» no cabe.
const CORTO = { P: 'Proteína', H: 'Hidratos', G: 'Grasas' };

const cuentas = (llevas, objetivo, m) => {
    const meta = Math.max(0, objetivo?.[m] || 0);
    const lleva = Math.max(0, llevas?.[m] || 0);
    const resta = meta - lleva;
    const pct = meta > 0 ? Math.min(100, Math.round((lleva / meta) * 100)) : 0;
    return { meta, lleva, resta, pct, pasado: resta < -0.5, cuadra: Math.abs(resta) < 0.5 };
};

const Celda = ({ etiqueta, valor, color, resaltada }) => (
    <div className="flex-1 min-w-0 rounded-xl px-1.5 py-2 text-center"
        style={{ backgroundColor: resaltada ? `${color}26` : 'rgba(255,255,255,0.05)' }}>
        <p className="text-[11px] text-muted-foreground truncate">{etiqueta}</p>
        <p className="font-heading text-xl font-bold leading-tight" style={{ color: resaltada ? color : undefined }}>
            {valor}<span className="text-xs text-muted-foreground font-sans font-medium ml-0.5">g</span>
        </p>
    </div>
);

const Anillo = ({ pct, color, lleva, meta }) => {
    const r = 52;
    const c = 2 * Math.PI * r;
    return (
        <div className="relative w-[88px] h-[88px] md:w-36 md:h-36 flex-shrink-0">
            <svg viewBox="0 0 120 120" className="w-full h-full -rotate-90">
                <circle cx="60" cy="60" r={r} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="9" />
                <circle cx="60" cy="60" r={r} fill="none" stroke={color} strokeWidth="9" strokeLinecap="round"
                    strokeDasharray={c} strokeDashoffset={c - (c * pct) / 100}
                    className="transition-all duration-700" />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className="text-[9px] md:text-[10px] font-bold uppercase tracking-wider md:tracking-widest text-muted-foreground">Llevas</span>
                <span className="font-heading text-2xl md:text-4xl font-bold text-white leading-none my-0.5 md:my-1">{num0(lleva)}</span>
                <span className="text-[10px] md:text-xs text-muted-foreground">de {num0(meta)} g</span>
            </div>
        </div>
    );
};

const TarjetaMacro = ({ m, llevas, objetivo }) => {
    const c = cuentas(llevas, objetivo, m);
    const color = COLOR_MACRO[m];
    return (
        <section className="rounded-2xl border p-2.5 sm:p-4 md:p-5 flex flex-col min-w-0" data-testid={`macro-${m}`}
            style={{ borderColor: `${color}50`, background: `linear-gradient(180deg, rgba(255,255,255,0.02), ${color}18)` }}>
            <p className="flex items-center justify-center md:justify-start gap-1.5 md:gap-2 text-[11px] md:text-sm font-bold uppercase tracking-wide md:tracking-widest truncate" style={{ color }}>
                <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: color }} />
                <span className="md:hidden">{CORTO[m]}</span><span className="hidden md:inline">{NOMBRE[m]}</span>
            </p>
            <div className="flex flex-col items-center mt-3 mb-1 md:my-4">
                <Anillo pct={c.pct} color={color} lleva={c.lleva} meta={c.meta} />
                <div className="min-w-0 text-center">
                    {!c.cuadra && (
                        <>
                            <p className="md:hidden mt-2 text-[11px] text-muted-foreground leading-none">{c.pasado ? 'Te pasas' : 'Faltan'}</p>
                            <p className="md:hidden font-heading text-xl font-bold leading-tight" style={{ color }}>
                                {num0(Math.abs(c.resta))} g
                            </p>
                            <p className="hidden md:block font-heading text-2xl font-bold mt-3" style={{ color }}>
                                {c.pasado ? `Te pasas ${num0(-c.resta)} g` : `Faltan ${num0(c.resta)} g`}
                            </p>
                        </>
                    )}
                    <p className={`text-[10px] md:text-xs text-muted-foreground ${c.cuadra ? 'mt-2 md:mt-0' : ''}`}>{c.pct}% de tu macro</p>
                </div>
            </div>
            <div className="hidden md:flex gap-1.5 mt-auto">
                <Celda etiqueta="Llevas" valor={num0(c.lleva)} color={color} />
                <Celda etiqueta="Macro" valor={num0(c.meta)} color={color} />
                <Celda etiqueta={c.pasado ? 'Te pasas' : 'Faltan'} valor={num0(Math.abs(c.resta))} color={color} resaltada />
            </div>
        </section>
    );
};

const MacrosHoy = ({ llevas, objetivo }) => (
    <div className="space-y-3 scroll-mt-20 lg:scroll-mt-6" data-testid="tu-dieta-hoy">
        <div className="grid grid-cols-3 gap-2 md:gap-3">
            {['P', 'H', 'G'].map((m) => <TarjetaMacro key={m} m={m} llevas={llevas} objetivo={objetivo} />)}
        </div>
    </div>
);

export default MacrosHoy;
